import React from "react";
import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    WhatsappIcon,
    LinkedinShareButton,
    LinkedinIcon,
} from "react-share";
import { Helmet } from "react-helmet-async";

const SocialMediaShare = ({ url, title, image, description }) => {
    return (
        <div className="social-share-wrapper">
            <Helmet>
                <title>{title}</title>
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content={image} />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
            </Helmet>

            <div className="social-share-buttons">
                <FacebookShareButton url={url} quote={title}>
                    <div className="share-button facebook">
                        <FacebookIcon size={24} round />
                        <span className="share-label">Facebook</span>
                    </div>
                </FacebookShareButton>

                <TwitterShareButton url={url} title={title}>
                    <div className="share-button twitter">
                        <TwitterIcon size={24} round />
                        <span className="share-label">Twitter</span>
                    </div>
                </TwitterShareButton>

                <WhatsappShareButton url={url} title={title}>
                    <div className="share-button whatsapp">
                        <WhatsappIcon size={24} round />
                        <span className="share-label">WhatsApp</span>
                    </div>
                </WhatsappShareButton>

                <LinkedinShareButton url={url}>
                    <div className="share-button linkedin">
                        <LinkedinIcon size={24} round />
                        <span className="share-label">LinkedIn</span>
                    </div>
                </LinkedinShareButton>
            </div>
        </div>
    );
};

export default SocialMediaShare;
